import { render, staticRenderFns } from "./BroadcastList.vue?vue&type=template&id=6269d21a"
import script from "./BroadcastList.vue?vue&type=script&lang=js"
export * from "./BroadcastList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports